export default __webpack_public_path__ + "d3e3b71e94b28b4355c10b392ab68b29.webp";